import { useEffect, useState } from 'react'
import { Box, Heading, Text, SimpleGrid, Flex, Spinner, Divider } from '@chakra-ui/react'
import axios from 'axios'

export default function AdminRevenue() {
  const [data, setData] = useState(null)
  useEffect(() => { axios.get('/api/admin/revenue').then(r => setData(r.data)).catch(() => {}) }, [])
  if (!data) return <Box p={8}><Spinner color="brand.orange" /></Box>

  return (
    <Box p={8}>
      <Heading size="lg" fontFamily="Georgia, serif" color="brand.darkBlue" mb={2}>Revenue</Heading>
      <Text fontSize="14px" color="gray.500" mb={8}>Real-time revenue breakdown</Text>
      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={5} mb={6}>
        <Box bg="white" borderRadius="12px" border="1px solid #E2E2E2" p={6}>
          <Text fontSize="12px" color="gray.500" textTransform="uppercase" letterSpacing="0.8px" mb={1}>Monthly Recurring Revenue</Text>
          <Text fontSize="40px" fontWeight="700" fontFamily="Georgia, serif" color="brand.darkBlue">${data.total_mrr}</Text>
          <Text fontSize="14px" color="gray.400" mt={1}>${data.total_arr} annually</Text>
        </Box>
        <Box bg="brand.darkBlue" borderRadius="12px" p={6} color="white">
          <Text fontSize="12px" color="rgba(255,255,255,0.5)" textTransform="uppercase" letterSpacing="0.8px" mb={4}>Breakdown</Text>
          {[['Platform Authors', data.platform_author.subscribers, '$' + data.platform_author.mrr + '/mo'], ['External Users', data.external.subscribers, '$' + data.external.mrr + '/mo']].map(([l, s, r]) => (
            <Flex key={l} justify="space-between" py={2} borderBottom="1px solid rgba(255,255,255,0.1)">
              <Box><Text fontSize="13px">{l}</Text><Text fontSize="11px" color="rgba(255,255,255,0.4)">{s} subscribers @ ${l === 'Platform Authors' ? data.platform_author.price : data.external.price}/mo</Text></Box>
              <Text fontSize="14px" fontWeight="500" color="brand.orange">{r}</Text>
            </Flex>
          ))}
        </Box>
      </SimpleGrid>
    </Box>
  )
}
